import { render } from "./DetalleSolicitudesView.vue?vue&type=template&id=7ee068f4"
import script from "./DetalleSolicitudesView.vue?vue&type=script&lang=js"
export * from "./DetalleSolicitudesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__